module.exports = __webpack_public_path__ + "media/images/winner--left-0ed5152a3abf365e5a44989191cef46b.png";